export { default } from "./Stack";
